import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const {
  colors,
  breakpoints: { BreakpointNames },
} = constants;
const { mediaQuery } = mediaQueryStyles;

export const chipGroupCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",

  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textS,
  fontWeight: 400,
  ...typographyStyles.lineHeight.l24,
  color: colors.ui.black[700],
  li: {
    maxWidth: "300px",

    span: {
      maxWidth: "300px",
    },
  },

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    flexDirection: "column",
  },
};

export const numberOfItemsCss: CSSObject = {
  maxWidth: "17%",

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    maxWidth: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
};

export const chipContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "8px",
  maxWidth: "83%",

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    maxWidth: "78%",
  },
  [mediaQuery.upTo(BreakpointNames.xs)]: {
    maxWidth: "60%",
  },
};

export const viewHideAllButtonCss: CSSObject = {
  [mediaQuery.downTo(BreakpointNames.sm)]: {
    display: "none",
  },
};

export const viewHideAllIconCss = [
  {
    width: "16px",
    height: "16px",
  },
];

export const viewHideAllContainerCss = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};
